import { toast as sonnerToast } from "sonner";
import React from "react";

// 커스텀 토스트 함수들
export const toast = {
  success: (message: string, options?: any) => {
    return sonnerToast.success(message, {
      className: "custom-toast toast-success",
      icon:
        options?.icon ||
        React.createElement("img", {
          src: "/icons/toastSuccess.svg",
          alt: "success",
          width: 16,
          height: 16,
        }),
      ...options,
    });
  },

  error: (message: string, options?: any) => {
    return sonnerToast.error(message, {
      className: "custom-toast toast-error",
      icon:
        options?.icon ||
        React.createElement("img", {
          src: "/icons/toastError.svg",
          alt: "error",
          width: 16,
          height: 16,
        }),
      ...options,
    });
  },

  warning: (message: string, options?: any) => {
    return sonnerToast.warning(message, {
      className: "custom-toast toast-warning",
      icon:
        options?.icon ||
        React.createElement("img", {
          src: "/icons/toastWaring.svg", // 원본 파일명 그대로 사용
          alt: "warning",
          width: 16,
          height: 16,
        }),
      ...options,
    });
  },

  info: (message: string, options?: any) => {
    return sonnerToast.info(message, {
      className: "custom-toast toast-info",
      icon:
        options?.icon ||
        React.createElement("img", {
          src: "/icons/toastInfo.svg",
          alt: "info",
          width: 16,
          height: 16,
        }),
      ...options,
    });
  },

  loading: (message: string, options?: any) => {
    return sonnerToast.loading(message, {
      className: "custom-toast toast-loading",
      icon: options?.icon || "⏳", // 로딩은 기본 이모지 사용
      ...options,
    });
  },

  // 커스텀 스타일 토스트들
  gradient: (message: string, options?: any) => {
    return sonnerToast(message, {
      className: "custom-toast toast-gradient",
      icon: options?.icon || "🌈",
      ...options,
    });
  },

  dark: (message: string, options?: any) => {
    return sonnerToast(message, {
      className: "custom-toast toast-dark",
      icon: options?.icon || "🌙",
      ...options,
    });
  },

  transparent: (message: string, options?: any) => {
    return sonnerToast(message, {
      className: "custom-toast toast-transparent",
      icon: options?.icon || "👻",
      ...options,
    });
  },

  // 애니메이션 토스트들
  bounce: (message: string, type: "success" | "error" | "warning" | "info" = "success", options?: any) => {
    const iconMap = {
      success: "/icons/toastSuccess.svg",
      error: "/icons/toastError.svg",
      warning: "/icons/toastWaring.svg",
      info: "/icons/toastInfo.svg",
    };

    return sonnerToast[type](message, {
      className: `custom-toast toast-${type} toast-bounce`,
      icon:
        options?.icon ||
        React.createElement("img", {
          src: iconMap[type],
          alt: type,
          width: 24,
          height: 24,
        }),
      ...options,
    });
  },

  pulse: (message: string, type: "success" | "error" | "warning" | "info" = "success", options?: any) => {
    const iconMap = {
      success: "/icons/toastSuccess.svg",
      error: "/icons/toastError.svg",
      warning: "/icons/toastWaring.svg",
      info: "/icons/toastInfo.svg",
    };

    return sonnerToast[type](message, {
      className: `custom-toast toast-${type} toast-pulse`,
      icon:
        options?.icon ||
        React.createElement("img", {
          src: iconMap[type],
          alt: type,
          width: 16,
          height: 16,
        }),
      ...options,
    });
  },

  // 커스텀 이미지 전용 함수들
  withImage: (message: string, imagePath: string, options?: any) => {
    return sonnerToast(message, {
      className: "custom-toast",
      icon: React.createElement("img", {
        src: imagePath,
        alt: "toast-icon",
        width: 16,
        height: 16,
        // className: "rounded-full",
      }),
      ...options,
    });
  },

  // 기본 sonner 함수들도 제공
  dismiss: sonnerToast.dismiss,
  promise: sonnerToast.promise,
};
